import React, { RefObject, useEffect, useRef, useState } from 'react'
import { gsap } from 'gsap'

type Accordion = {
  isOpen: boolean
  toggle: () => void
  targetRef: RefObject<HTMLDivElement>
  initialStyle: React.CSSProperties
}

export const useAccordion = (defaultOpen = false): Accordion => {
  const [isOpen, setIsOpen] = useState(defaultOpen)
  const targetRef = useRef<HTMLDivElement>(null)
  const isFirstRender = useRef(true)

  useEffect(() => {
    if (!targetRef.current) return

    const height = isOpen ? 'auto' : 0
    if (isFirstRender.current) {
      isFirstRender.current = false
      gsap.set(targetRef.current, { height })
      return
    }
    gsap.to(targetRef.current, { height, duration: 0.3 })
  }, [isOpen])

  const toggle = () => setIsOpen((prev) => !prev)

  return { isOpen, toggle, targetRef, initialStyle: { height: defaultOpen ? 'auto' : 0 } }
}
